// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__gp3VT","list":"NavBar_list__lwtLI","item":"NavBar_item__qAbNY"};